import {
  generateBrandUrlForSDUIProductTile,
  generateSDUIProductLinkPropsWithLeanProps,
} from "@faire/deprecated-retailer-visitor-shared/components/SDUI/ComponentRenderers/Tile/__internal__/SDUIProductTileUrlHandlerUtil";
import { DisplayPageType } from "@faire/web-api--source/indigofair/data/DisplayPageType";
import { getLocation } from "@faire/web/common/globals/getLocation";
import { useCallback } from "react";

export const useGenerateProductLinkPropsForSDUIProductTileHandler = (
  productToken?: string,
  productOptionToken?: string,
  impressionId?: string,
  display_page?: keyof typeof DisplayPageType
) => {
  const location = getLocation();

  return useCallback(() => {
    return {
      productUrl: generateSDUIProductLinkPropsWithLeanProps(
        {
          productToken: productToken,
          selectedProductOptionToken: productOptionToken,
          impressionId: impressionId,
        },
        location?.pathname ?? "",
        location?.search ?? "",
        display_page
      ),
    };
  }, [display_page, location, productToken, productOptionToken, impressionId]);
};

export const useGenerateBrandUrlForSDUIProductTileHandler = (
  productToken?: string,
  brandToken?: string,
  impressionId?: string,
  display_page?: keyof typeof DisplayPageType,
  isLoggedInRetailer?: boolean
) => {
  const location = getLocation();

  return useCallback(() => {
    return generateBrandUrlForSDUIProductTile(
      location?.pathname ?? "",
      location?.search ?? "",
      productToken,
      impressionId,
      brandToken,
      display_page,
      isLoggedInRetailer
    );
  }, [
    display_page,
    location,
    productToken,
    impressionId,
    brandToken,
    isLoggedInRetailer,
  ]);
};
